import React from 'react';
import './ListCollapse.css';
import { Collapse, Button, CardBody, Card, ListGroup, ListGroupItem, Row, Col, Container } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/fontawesome-free-solid';
import BimeManager from '../../Core/BimeManager';
import Axios from 'axios';
import UserManager from '../../Core/UserManager';
import Config from '../../Core/Config.js';
import {framework,ui} from 'saffroncodejs';
var PageManager = framework.PageManager ;

class ListCollapse extends React.Component {

    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.redirect = this.redirect.bind(this);
        this.pagechange = this.pagechange.bind(this);
        this.state = {
            collapse: false,
            items: [
                {
                    id: 0, btnText: 'اتومبیل - بدنه', collapse: true, itemsInItem: [
                        { itemInId: 0, code: '123336544 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                        { itemInId: 1, code: '123336545 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                        { itemInId: 2, code: '123336546 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                        { itemInId: 3, code: '123336547 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                    ]
                },
                {
                    id: 1, btnText: 'اتومبیل - ثالث', collapse: false, itemsInItem: [
                        { itemInId: 0, code: '222336544 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                        { itemInId: 1, code: '23232323336545 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                        { itemInId: 2, code: '223233336546 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                        { itemInId: 3, code: '23232323336547 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                    ]
                },
                {
                    id: 2, btnText: 'اتومبیل', collapse: false, itemsInItem: [
                        { itemInId: 0, code: '32222336544 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                        { itemInId: 1, code: '322233336545 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                        { itemInId: 2, code: '3444336546 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                        { itemInId: 3, code: '3567536547 ', name: 'نام کاربر', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840' },
                    ]
                },
            ],
            isloading:true
        }
        this.state.items=[];
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Cmn/api/Person/Policies",
           
                { codeMelli:  UserManager.MelliCode() }
            ),
            BimeManager.header())
            .then(this.ResultExport.bind(this))
            .catch((error) => { alert(error) })
    }

    ResultExport(respond) {
     
        var result = [
            { "FullBNo": "95/03/3237/3237/3005350", "BeginDate": "1395/10/27", "EndDate": "1396/10/27", "SodurDate": "1395/10/27", "Reshte": 5, "ReshteText": "اتومبيل - ثالث", "BimeGozarText": "ايمان کشاورز کد 2554189", "SodurId": 4471221, "ElhNo": 0, "Bill": null, "MoredeBime": null, "MoredeBimeText": null, "ErrorMessage": null },
            { "FullBNo": "92/28/99/99/3522964", "BeginDate": "1392/11/10", "EndDate": "1393/11/10", "SodurDate": "1392/11/09", "Reshte": 4, "ReshteText": "اتومبیل بدنه", "BimeGozarText": "روزيتا حقيقي کد 2040420", "SodurId": 379089, "ElhNo": 0, "Bill": null, "MoredeBime": null, "MoredeBimeText": null, "ErrorMessage": null },
            { "FullBNo": "95/08/3237/3237/8001218", "BeginDate": "1395/10/28", "EndDate": "1396/10/28", "SodurDate": "1395/10/27", "Reshte": 17, "ReshteText": "حوادث انفرادي", "BimeGozarText": "ايمان کشاورز کد 2554189", "SodurId": 292837, "ElhNo": 0, "Bill": null, "MoredeBime": null, "MoredeBimeText": null, "ErrorMessage": null },
            { "FullBNo": "96/05/870/3476/5400021", "BeginDate": "1396/06/09", "EndDate": "1397/06/09", "SodurDate": "1396/06/09", "Reshte": 12, "ReshteText": "مسئولیت حرفه ای پزشکان", "BimeGozarText": "علي عزتي کد 1578193", "SodurId": 24659, "ElhNo": 0, "Bill": null, "MoredeBime": null, "MoredeBimeText": null, "ErrorMessage": null },
        ]
        result = respond.data;
        var i; 
        var items = [
            {
                id: 0, btnText: 'اتومبیل - بدنه', collapse: true, itemsInItem: [
                  { itemInId: 0, code: '123336544 ', name: 'زهره طبسی', startDate: '90/04/12', endDate: '97/01/12', insuranceNumber: '95/03/99/99/3021840',moredbime:58 },
                ]
            }]
         

        var subGroupsListIds= [] ;
        items = [];
        for(i = 0 ; i<result.length ; i++)
        {
            if(subGroupsListIds.indexOf(result[i].Reshte)===-1)
            {
                subGroupsListIds.push(result[i].Reshte);
                items.push( {id:result[i].Reshte, btnText:result[i].ReshteText, collapse: false, itemsInItem:[]});
            }
        }
        for(i=0;i<items.length ; i++)
        {
            for(var j = 0 ; j<result.length ; j++)
            {
                if(items[i].id===result[j].Reshte)
                {
                    items[i].itemsInItem.push({itemInId: result[j].SodurId, code:result[j].Reshte, name:result[j].BimeGozarText, startDate:result[j].BeginDate, endDate:result[j].EndDate, insuranceNumber:result[j].FullBNo,moredbime:result[j].MoredeBime});
                   // items[i].itemsInItem.push({itemInId: result[j].SodurId, code:result[j].SodurId, name:'zohreh', startDate:result[j].BeginDate, endDate:result[j].EndDate, insuranceNumber:result[j].FullBNo});
                }
            }
         
        }

        
        this.setState({items:items,isloading:false});
        console.log('items***********&&&***********&&&',this.state.items);
    }
    

    toggle(num) {

        var listitems = this.state.items;
        /*for(var i = 0 ;i<listitems.length ; i++)
        {
            if(listitems[i].id === num)
            {
                listitems[i].collapse = !listitems[i].collapse ;
                break ;
            }
        }*/
        var p = listitems.find(x => x.id === num);
        p.collapse = !p.collapse;
        this.setState({ items: listitems });
        console.log('items2***********&&&',this.state.items);
    }
    
    pagechange(reshteInput,SodurID,bimeNameName,reshtepool) {
        switch (reshteInput) {
            case 5:
                PageManager.changePage(Config.p_details, [SodurID,bimeNameName]);
                break;
            case 1:
                PageManager.changePage(Config.p_atashsuzi, [SodurID,bimeNameName]);
                break;
            case 4:
                PageManager.changePage(Config.p_badane, [SodurID,bimeNameName]);
                break;
                case 20:
                PageManager.changePage(Config.p_havadesguruhi, [SodurID,bimeNameName]);
                break;
                case 2:
                PageManager.changePage(Config.p_atashsuzigheirSanati, [SodurID,bimeNameName]);
                break;
                case 3:
                PageManager.changePage(Config.p_atashsuzimaskuni, [SodurID,bimeNameName]);
                break;
                case 213:
                PageManager.changePage(Config.p_atashsuzianbar, [SodurID,bimeNameName]);
                break;
                case 8:
                PageManager.changePage(Config.p_barbaridakheli, [SodurID,bimeNameName]);
                break;
                case 7:
                PageManager.changePage(Config.p_barbarivaredati, [SodurID,bimeNameName]);
                break;
                case 6:
                PageManager.changePage(Config.p_barbarisaderati, [SodurID,bimeNameName]);
                break;
                case 12:
                PageManager.changePage(Config.p_pezeshkan, [SodurID,bimeNameName]);
                break;
                case 13:
                PageManager.changePage(Config.p_pirapezeshkan, [SodurID,bimeNameName]);
                break;
                case 11:
                PageManager.changePage(Config.p_hamlonaghl, [SodurID,bimeNameName]);
                break;
                case 9:
                PageManager.changePage(Config.p_abnie, [SodurID,bimeNameName]);
                break;
                case 101:
                PageManager.changePage(Config.p_sanati, [SodurID,bimeNameName]);
                break;
                case 14:
                PageManager.changePage(Config.p_omrani, [SodurID,bimeNameName]);
                break;
                case 10:
                PageManager.changePage(Config.p_karfarmasakhtemani, [SodurID,bimeNameName]);
                break;
                case 15:
                PageManager.changePage(Config.p_madani, [SodurID,bimeNameName]);
                break;
                case 103:
                PageManager.changePage(Config.p_omrosarmayegozari, [SodurID,bimeNameName]);
                break;
                case 53:
                PageManager.changePage(Config.p_mashinalat, [SodurID,bimeNameName]);
                break;
                case 56:
                PageManager.changePage(Config.p_sazehayetakmilshode, [SodurID,bimeNameName]);
                break;
                case 54:
                PageManager.changePage(Config.p_shekastmashinalat, [SodurID,bimeNameName]);
                break;
                case 55:
                PageManager.changePage(Config.p_tajhizatelekteroniki, [SodurID,bimeNameName]);
                break;
                case 51:
                PageManager.changePage(Config.p_tamamkhatar, [SodurID,bimeNameName]);
                break;
                case 57:
                PageManager.changePage(Config.p_sayer, [SodurID,bimeNameName]);
                break;
                case 91:
                PageManager.changePage(Config.p_havapeyma, [SodurID,bimeNameName]);
                break;
                case 107:
                if(reshtepool===59)
                {

                    PageManager.changePage(Config.p_puldarjaryan, [SodurID,bimeNameName]);
                }
                if(reshtepool===58)
                {

                    PageManager.changePage(Config.p_puldarsandogh, [SodurID,bimeNameName]);
                }
                break;
                case 92:
                PageManager.changePage(Config.p_Keshti, [SodurID,bimeNameName]);
                break;
                case 34:
                PageManager.changePage(Config.p_axa, [SodurID,bimeNameName]);
                break;
                case 225:
                PageManager.changePage(Config.p_sos, [SodurID,bimeNameName]);
                break;
                case 35:
                PageManager.changePage(Config.p_mapfree, [SodurID,bimeNameName]);
                break;
                case 17:
                PageManager.changePage(Config.p_havadesenferadi, [SodurID,bimeNameName]);
                break;
                case 52:
                PageManager.changePage(Config.p_tamamkhatarpeymankari, [SodurID,bimeNameName]);
                break;
                case 18:
                PageManager.changePage(Config.p_omrguruhi, [SodurID,bimeNameName]);
                break;
                case 16:
                PageManager.changePage(Config.p_omrenferdi, [SodurID,bimeNameName]);
                break;
                case 110:
                PageManager.changePage(Config.p_marhunati, [SodurID,bimeNameName]);
                break;
                case 268:
                PageManager.changePage(Config.p_tashkilsarmaye, [SodurID,bimeNameName]);
                break;
                case 21:
                PageManager.changePage(Config.p_darman, [SodurID,bimeNameName]);
                break;
                case 201:
                PageManager.changePage(Config.p_oyoubasasivapenhan, [SodurID,bimeNameName]);
                break;
                case 58:
                PageManager.changePage(Config.p_oyoubasasivapenhan, [SodurID,bimeNameName]);
                break;
                case 95:
                PageManager.changePage(Config.p_asb, [SodurID,bimeNameName]);
                break;
            default:
            alert('محتوای رشته مورد نظر موجود نمی باشد')
        }

    }
    

    redirect(btnItem, id) {
        return ('/Detail')
    }
    render() {
        const items = this.state.items;
        console.log('items2*',items);
        //var num = 0;
        if (this.state.isloading===true)
        {
           
         return (
        <div className="collapse-list container">
            <Row>
            <Col sm="12">
                <h4>بیمه نامه های من</h4>
            </Col>
        </Row>
            <ui.Preloader/>
            
        </div>
         )
      
        }
        
        return (
            <div className="collapse-list container">
                
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>بیمه نامه های من</h4>
                    </Col>
                </Row>
                {(items.length!==0 && items )? items.map((item) => (
                    
                    <div key={item.id} >
                        <Button color="collapse" onClick={() => { this.toggle(item.id) }}> <FontAwesomeIcon icon={faAngleDown} />&nbsp;{item.btnText} </Button>
                        <Collapse isOpen={item.collapse}>
                            <Card>
                                <CardBody>
                                    <ListGroup>
                                        {item.itemsInItem.map((itemIn) => (
                                                <div onClick={() => { this.pagechange(item.id,itemIn.itemInId,itemIn.insuranceNumber,itemIn.moredbime) }}>

                                                    <ListGroupItem >
                                                        <Container>
                                                            <Row >
                                                                <Col sm="12" className="clear alignCenter"><span className="text-format">{itemIn.name}</span>&nbsp; کد<span className="text-format">{itemIn.code}</span> </Col>

                                                                <Col sm="6" className="alignRight"> <span>شروع: </span><span className="date-format">{itemIn.startDate}</span> </Col> <Col sm="6" className="alignRight"> <span>پایان:</span><span className="date-format">{itemIn.endDate}</span> </Col>
                                                                <Col sm="12" className="alignRight"> <span>مورد بیمه: </span><span className="footerlist-format">{itemIn.moredbime}</span> </Col>
                                                                <Col sm="12" calssName="clear alignCenter"><div className="text-format  alignCenter">{itemIn.insuranceNumber}</div></Col>
                                                            </Row>
                                                        </Container>
                                                    </ListGroupItem>

                                                </div>
                                            ))
                                        }
                                    </ListGroup>
                                </CardBody>
                            </Card>
                        </Collapse>
                    </div>
                )):<div>
                    <ListGroup>
                    <ListGroupItem >
                        <Container>
                            <Row >
                                <Col sm="12" className="clear alignCenter"><span className="text-format">لیست بیمه نامه های شما خالی می باشد</span> </Col>

                            </Row>
                        </Container>
                    </ListGroupItem >   
                    </ListGroup>
                </div>
                    }
            </div>
        );
    }
}

export default ListCollapse;



// WEBPACK FOOTER //
// ./src/components/ListCollapse/ListCollapse.js